/**
 * MSG-6 (решение 9 тикета): safety number v1 — ОБЩАЯ конвенция клиентов.
 * КОПИЯ эталона `tools/msg5-harness/node/safety-number.mjs` (зеркало
 * Kotlin-реализации SafetyNumber.kt). Менять ТОЛЬКО синхронно с эталоном и
 * Kotlin — общий тест-вектор в msg-модуле пиниет совпадение до цифры.
 *
 * Формула (менять после релиза нельзя — только новая метка версии):
 * ed25519-ключи ОБЕИХ сторон как сырые байты (unpadded base64 стандартного
 * алфавита), упорядоченные лексикографически по беззнаковым байтам;
 * h = SHA-512("total-msg-sn-v1" ‖ k_min ‖ k_max); 12 групп по 5 цифр:
 * группа i = uint40 big-endian из h[5i..5i+4] mod 100000.
 *
 * Симметрично по построению — обе стороны читают ОДНО число вслух (§2.1 п.3).
 * Асинхронно, потому что считает через WebCrypto: один код на Node и браузер.
 */
const LABEL = "total-msg-sn-v1";
const GROUPS = 12;

function decodeKey(b64) {
    const binary = atob(b64);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
    if (bytes.length !== 32) {
        throw new Error(`ed25519-ключ обязан быть 32 байта, пришло ${bytes.length}`);
    }
    return bytes;
}

function compareUnsigned(a, b) {
    for (let i = 0; i < Math.min(a.length, b.length); i++) {
        if (a[i] !== b[i]) return a[i] - b[i];
    }
    return a.length - b.length;
}

/** @param ownEd25519 @param peerEd25519 — unpadded base64 из бандлов. */
export async function safetyNumber(ownEd25519, peerEd25519) {
    const own = decodeKey(ownEd25519);
    const peer = decodeKey(peerEd25519);
    const [first, second] = compareUnsigned(own, peer) <= 0 ? [own, peer] : [peer, own];
    const label = new TextEncoder().encode(LABEL);
    const input = new Uint8Array(label.length + first.length + second.length);
    input.set(label, 0);
    input.set(first, label.length);
    input.set(second, label.length + first.length);
    const digest = new Uint8Array(
        await globalThis.crypto.subtle.digest("SHA-512", input));
    const groups = [];
    for (let i = 0; i < GROUPS; i++) {
        let acc = 0n;
        for (let j = 0; j < 5; j++) acc = (acc << 8n) | BigInt(digest[i * 5 + j]);
        groups.push(String(acc % 100000n).padStart(5, "0"));
    }
    return groups.join(" ");
}

/** ed25519 устройства из его бандла/device_keys (ключ вида `ed25519:<did>`). */
export function ed25519Of(deviceKeys, did) {
    const key = deviceKeys?.keys?.[`ed25519:${did}`];
    if (!key) throw new Error(`в device_keys нет ed25519:${did}`);
    return key;
}
